export default __webpack_public_path__ + "static/media/terrace2.9d8b53a1.jpg";